var $2f5377d3471630e5$exports = {};
$2f5377d3471630e5$exports = {
  "buttonLabel": "Wy\u015Bwietlaj sugestie",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "dost\u0119pna/dost\u0119pne(-nych) ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcja");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcje(-i)");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Do\u0142\u0105czono do grupy ".concat(args.groupTitle, ", z ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcj\u0105");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcjami");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", wybrano",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugestie",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", wybrano");
  }
};
export { $2f5377d3471630e5$exports as default };